/**
 * YNS Product Recommendations Configuration
 * Contains product catalog, category mappings, and recommendation settings.
 */

window.YNS_RECOMMENDATIONS = {
  // ============================================
  // Product Catalog
  // ============================================
  // Only handle, shortPitch, and badge are stored here.
  // id, title, price, and image are fetched dynamically from Shopify API.
  products: {
    fastTrackBundle: {
      handle: 'nclex-fasttrack\u2122-all-in-one-bundle-5-step-study-roadmap-with-personalized-planner-high-yield-lectures-3-000-cat-q-bank-crash-courses',
      shortPitch: 'Complete NCLEX prep package',
      badge: 'Best Value'
    },
    questionBank: {
      handle: '3-000-nclex-question-bank-nclex-rn-pn-practice-test-high-yield-qbank-with-rationales',
      shortPitch: '3,000+ practice questions with rationales',
      badge: 'Best Seller'
    },
    masteryNotes: {
      handle: '2026-nclex-ultimate-mastery-notes-nclex-high-yield-study-guide-with-mnemonics',
      shortPitch: 'High-yield review book for all topics'
    },
    crashCourse: {
      handle: '2026-nclex-crash-course-notes-high-yield-study-guide-test-taking-strategies',
      shortPitch: 'Quick review for last-minute prep'
    },
    pharmacologyNotes: {
      handle: 'pharmacology-study-guide-nclex-pharmacology-pages-2026-edition-nursing-ebook',
      shortPitch: '65+ pages covering all drug classes',
      badge: 'Popular'
    },
    klimekBundle: {
      handle: 'mark-klimek-2026-next-gen-nclex-review-latest-video-lectures-pdf-guides',
      shortPitch: 'Mark Klimek lectures + Blue & Yellow Book PDF'
    },
    flashcards: {
      handle: 'critical-care-nursing-medications-80511',
      shortPitch: 'Memorize key medications fast'
    },
    ecgBundle: {
      handle: 'ecg-dysrhythmia-interpretation-bundle-19100',
      shortPitch: 'Master cardiac rhythms step-by-step'
    }
  },

  // ============================================
  // Category to Product Mappings
  // ============================================
  // Products listed in priority order (first = most relevant)
  categoryMapping: {
    'pharmacology': ['pharmacologyNotes', 'flashcards', 'questionBank'],
    'fundamentals': ['masteryNotes', 'crashCourse', 'questionBank'],
    'mental-health': ['klimekBundle', 'pharmacologyNotes', 'questionBank'],
    'prioritization': ['crashCourse', 'questionBank', 'masteryNotes'],
    'pediatrics': ['masteryNotes', 'crashCourse', 'questionBank'],
    'cardiac': ['ecgBundle', 'flashcards', 'pharmacologyNotes'],
    'nclex-prep': ['fastTrackBundle', 'questionBank', 'klimekBundle']
  },

  // ============================================
  // Video-Specific Overrides
  // ============================================
  // For specific videos that should show different products
  videoOverrides: {
    'Cardiac Rhythms (Arrhythmias)': ['ecgBundle', 'flashcards'],
    'Cardiac Drugs (Calcium Channel)': ['ecgBundle', 'pharmacologyNotes'],
    'Diabetes (Part 1)': ['pharmacologyNotes', 'masteryNotes'],
    'Diabetes Medications (Part 2)': ['pharmacologyNotes', 'flashcards'],
    'Psychotropic Drugs': ['pharmacologyNotes', 'klimekBundle'],
    'Psychotropic Drugs Part 2': ['pharmacologyNotes', 'klimekBundle'],
    'Electrolytes': ['flashcards', 'masteryNotes'],
    'ABGs (Acid Base Part 1)': ['flashcards', 'masteryNotes'],
    'Acid-Base Imbalances (Part 2)': ['flashcards', 'masteryNotes'],
    'Congenital Heart': ['masteryNotes', 'ecgBundle'],
    'Maternal Newborn': ['masteryNotes', 'crashCourse'],
    'Maternal Newborn Part 2': ['masteryNotes', 'crashCourse'],
    'Alcoholism Part 1': ['klimekBundle', 'pharmacologyNotes'],
    'Alcoholism Part 2': ['klimekBundle', 'pharmacologyNotes'],
    'Delusions Part 1': ['klimekBundle', 'masteryNotes'],
    'Delusions & Hallucinations (Part 2)': ['klimekBundle', 'masteryNotes'],
    'Psych Treatment Principles': ['klimekBundle', 'pharmacologyNotes']
  },

  // ============================================
  // Universal Fallback
  // ============================================
  // Used when category has no mapping or all mapped products are owned
  universalFallback: ['fastTrackBundle', 'questionBank', 'masteryNotes'],

  // ============================================
  // Settings
  // ============================================
  settings: {
    progressThreshold: 30,        // Show recommendations at 30% video progress
    maxProducts: 2,               // Maximum products to show at once
    dismissCooldownMinutes: 60,   // Don't show again for 60 minutes after dismiss
    completionDelayMs: 2000,      // Delay before showing after video completion
    storageKey: 'yns_reco_state'  // localStorage key for state management
  }
};
